function viteEnv(key: keyof ImportMetaEnv): string | undefined {
  const value = import.meta.env[key]
  return typeof value === 'string' ? value : undefined
}

export const isDev = import.meta.env.DEV

export const appMode = (viteEnv('VITE_APP_MODE') === 'warehouse_delman' ? 'warehouse_delman' : 'warehouse') as
  | 'warehouse'
  | 'warehouse_delman'

/** Base URL superoti-warehouse-server, sudah termasuk prefix /api/v1 (lihat README repo tsb). */
export const apiBaseUrl = viteEnv('VITE_API_URL') ?? 'http://localhost:8082/api/v1'
